import * as Icons from "lucide-react";
import storeCategories from "./StoreCategoryList.json";

const PRODUCT_BY_ID = new Map(
  (storeCategories.productCategories || []).map((entry) => [entry.id, entry])
);
const SERVICE_BY_ID = new Map(
  (storeCategories.serviceCategories || []).map((entry) => [entry.id, entry])
);

/**
 * @param {string} categoryId
 * @returns {{ id: string, name: string, icon: string } | null}
 */
export function getCategoryById(categoryId) {
  const id = String(categoryId || "").trim();
  if (!id) return null;
  return PRODUCT_BY_ID.get(id) || SERVICE_BY_ID.get(id) || null;
}

/**
 * @param {string} categoryId
 * @returns {string}
 */
export function getCategoryLabel(categoryId) {
  return getCategoryById(categoryId)?.name || "";
}

/**
 * Resolve a Lucide icon component for a category id.
 * @param {string} categoryId
 */
export function getCategoryIcon(categoryId) {
  const entry = getCategoryById(categoryId);
  if (!entry) return Icons.Store;
  return Icons[entry.icon] || Icons.Store;
}

/**
 * Ordered category label lines for a store card (product then service; dedupe identical labels).
 * @param {{ productSegmentId?: string, serviceSegmentId?: string }} params
 * @returns {{ id: string, label: string }[]}
 */
export function getStoreCategoryLines({ productSegmentId, serviceSegmentId } = {}) {
  const productLabel = getCategoryLabel(productSegmentId);
  const serviceLabel = getCategoryLabel(serviceSegmentId);
  if (productLabel && serviceLabel && productLabel === serviceLabel) {
    return [{ id: productSegmentId, label: productLabel }];
  }
  const lines = [];
  if (productLabel) lines.push({ id: productSegmentId, label: productLabel });
  if (serviceLabel) lines.push({ id: serviceSegmentId, label: serviceLabel });
  return lines;
}
